/* eslint-disable react/prop-types */
import React from 'react'
import TopNavBar from '../../../components/navigation/TopNavBar'
import SpinnerLarge from '../../../components/SpinnerLarge'
import { useTheme } from '../../../utils/ThemeColorContext'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { silentLogout } from '../../../App'
import { useLDClient } from 'launchdarkly-react-client-sdk'

const Welcome = ({ children }) => {
  const { loadingWholeScreen, loading, loading2 } =
      useSelector((state) => state.dataReducer)
  const { color } = useTheme()
  const ldClient = useLDClient()

  useEffect(() => {
    const welcome = async () => {
      await silentLogout(ldClient)  
    }

    welcome()
  }, [])

  return (
    <>
      {(loadingWholeScreen || loading || loading2) ? (
          <SpinnerLarge />
        ) : (
          <div style={{ backgroundColor: color.LightGrey }} className="min-h-screen ">
            <TopNavBar
              forceModalOpen={true}
              disallowChangeEmail={true}
            />
      
            <div
              style={{
                minHeight: 'calc(100vh - 108px)',
              }}
              className={`mobilecta  bottom-0 w-full setBgForBigScreen md:pt-[64px] pb-[100px]    md:px-6 mt-[72px] md:mt-[0px] md:block lg:cta md:cta 'cta' md:pb-16`}
            >
              {children}
            </div>
            {/* <Footer /> */}
          </div>
        )
      }
    </>
  )
}

export default Welcome
